import { defineComponent as r, openBlock as a, createBlock as n, unref as l, mergeProps as p, withCtx as m, createElementVNode as c } from "vue";
import { RevIcon as s } from "@ds/components/Icon";
const d = /* @__PURE__ */ r({
  name: "IconSort",
  __name: "IconSort",
  props: {
    size: {},
    alternativeText: {}
  },
  setup(t) {
    const o = t;
    return (i, e) => (a(), n(l(s), p(o, { "view-box": "0 0 24 24" }), {
      default: m(() => [...e[0] || (e[0] = [
        c("path", { d: "M15.116 3.823 12.47 6.47a.75.75 0 0 0 1.06 1.06l1.72-1.72V17a.75.75 0 0 0 1.5 0V5.81l1.72 1.72a.75.75 0 1 0 1.06-1.06l-2.646-2.647a1.25 1.25 0 0 0-1.768 0M8.75 7a.75.75 0 0 0-1.5 0v11.19l-1.72-1.72a.75.75 0 1 0-1.06 1.06l2.646 2.647a1.25 1.25 0 0 0 1.768 0l2.646-2.647a.75.75 0 0 0-1.06-1.06l-1.72 1.72V7" }, null, -1)
      ])]),
      _: 1
    }, 16));
  }
});
export {
  d as default
};
